<template>
  <div class="">
    <div v-if="hasRole('System Administrator')" class="text-small text-gray">
      <a href="/assignment-admin">Assignments</a> > <a :href="'/assignments/'+assignmentToDo.userAssignmentId">{{ assignmentToDo.assignmentTemplateName }}</a> > {{ assignmentToDo.toDoItemName }}
    </div>
    <div v-else class="text-small text-gray">
      <a href="/assignments">Assignments</a> > <a :href="'/assignments/'+assignmentToDo.userAssignmentId">{{ assignmentToDo.assignmentTemplateName }}</a> > {{ assignmentToDo.toDoItemName }}
    </div>
    <div class="flex justify-center items-center  pt-5">
      <div class="w-full">
        <div class="flex justify-between items-center">
          <div class="h2 text-primary-500 ">
            {{ assignmentToDo.toDoItemName }}
          </div>
          <div>
            <div class="flex flex-row justify-end sp-x-1">
              <div v-if="hasRole('System Administrator')" class="flex cursor-pointer">
                <d-tooltip label="View All Assignees">
                  <d-icon v-if="assignment.assignmentTemplateGroupId != null" class="text-3xl" icon="users" @click="launchGroupAssigneesSideDrawer" />
                  <d-icon v-else class="text-3xl" icon="users" @click="launchIndividualAssigneesSideDrawer" />
                </d-tooltip>
              </div>

              <d-tooltip label="Feedback">
                <div class="cursor-pointer mr-2 ml-5" @click="launchToDoFeedbackSideDrawer()">
                  <span>({{ toDoFeedback.length }})</span>
                </div>
                <div class="flex cursor-pointer" @click="launchToDoFeedbackSideDrawer()">
                  <d-icon class="text-3xl" icon="comments" />
                </div>
              </d-tooltip>
            </div>
          </div>
        </div>
        <div class="mb-5">
          <div class="text-black">
            Due Date: {{ assignmentToDo.toDoItemDueDate | formatShortDate }}
          </div>
          <div v-if="assignmentToDo.latestSubmissionDate" class="text-black">
            Submission Date: {{ assignmentToDo.latestSubmissionDate | formatShortDate }}
          </div>
          <div v-if="assignmentToDo.completionDate" class="text-black">
            Completion Date: {{ assignmentToDo.completionDate | formatShortDate }}
          </div>
          <div v-if="assignmentToDo.userId !== profile.id" class="text-black">
            Assigned User: {{ assignmentToDo.userFullName }}
          </div>
           <div class="text-black mb-5">
             Reviewer: {{ assignmentToDo.assignmentReviewerFullName }}
           </div>
          <div class="wysiwyg-editor-container" v-html="assignmentToDo.toDoItemHtmlContent" />
        </div>
        <div v-if="!assignmentToDo.closed || hasRole('System Administrator')">
          <p v-if="assignmentToDo.closed">
            This task is closed to the assignee since it is past the due date.
          </p>
          <d-message v-if="assignmentToDo.submitted && !assignmentToDo.completed" type="info">
            <p class="font-bold">
              Task has been submitted for review
            </p>
            <p v-if="user.id == assignmentToDo.userId">
              This task is still pending review at this time. You can resubmit for review at any time by clicking the "Submit" button at the bottom.
            </p>
            <p v-else>
              This task has been submitted for review. You can choose to complete the task if desired (if you are the reviewer), otherwise send feedback to the assignee on what should be changed.
            </p>
          </d-message>
          <d-message v-if="assignmentToDo.completed" type="info">
            <p class="font-bold">
              Task Completed
            </p>
            <p>This task has been fully completed and can no longer be modified.</p>
          </d-message>
          <div v-if="userCanSubmit && !assignmentToDo.Completed">
            <div v-if="assignmentToDo.canBeStarted">
              <d-field required>
                <vue-editor v-model="assignmentToDo.content" type="textarea" class="text-3xl rounded-md bg-white border-gray-300 shadow-md mb-5" :editor-toolbar="customToolbar" />
              </d-field>
            </div>
            <div v-else>
              <d-message type="info">
                <p>This task will be available to submit on {{ assignmentToDo.startDateDisplay }}.</p>
              </d-message>
            </div>
          </div>
          <div v-else>
            <div v-if="assignmentToDo.content">
              <div class="wysiwyg-editor-container" v-html="assignmentToDo.content" />
            </div>
            <div v-else>
              <p><strong>No content has been submitted for this task</strong></p>
            </div>
          </div>

          <div class="flex justify-end ">
            <div v-if="userCanSubmit">
              <div v-if="!assignmentToDo.completed && assignmentToDo.canBeStarted">
                <d-btn @click="submitTodoForReview()">
                  Submit
                </d-btn>
              </div>
            </div>
            <div v-if="userCanComplete">
              <d-btn class="ml-5" @click="completeTodo()">
                Mark as Completed
              </d-btn>
            </div>
            <div v-if="userCanUncomplete">
              <d-btn class="ml-5" @click="uncompleteTodo()">
                Mark as Not Completed
              </d-btn>
            </div>
          </div>
        </div>
        <div v-else>
          <p>
            This task closed on {{ assignmentToDo.toDoItemDueDate | formatShortDate }} and can no longer be submitted.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  import FeedbackSideDrawer from './components/FeedbackSideDrawer';
  import IndividualAssigneeSideDrawer from '../AdminAssignments/components/IndividualAssigneeSideDrawer';
  import GroupAssigneesSideDrawer from '../AdminAssignments/components/GroupAssigneesSideDrawer';

  export default {
    parent: true,
    components: {
    },
    props: {
      user: {
        type: Object,
        default: () => { },
      },
      toDoId: {
        type: Number,
        default: () => 0,
      },
    },

    data: () => ({
      assignment: {},
      assignmentToDo: {},
      toDoFeedback: [],
      loadingToDo: false,
      loadingFeedback: false,
      saving: false,
      assignmentToDoForm: {
        completed: false,
        submitted: false,
        content: '',
      },
      customToolbar: [
        [{ header: [false, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['blockquote', 'code-block'],
        [{ indent: '-1' }, { indent: '+1' }], [{ color: [] }, { background: [] }], ['clean'],
        ['link'],
      ],
    }),

    computed: {
      ...mapGetters('d2Auth', ['profile', 'hasRole']),

      userCanSubmit() {
        if (this.assignmentToDo.completed) {
          return false;
        }
        if (this.hasRole('System Administrator')) {
          return true;
        }
        if (this.profile.id === this.assignmentToDo.userId) {
          return true;
        }

        return false;
      },
      userCanComplete() {
        if (!this.assignmentToDo.submitted) {
          return false;
        }
        if (this.assignmentToDo.completed) {
          return false;
        }

        if (this.hasRole('System Administrator')) {
          return true;
        }

        if (this.profile.id === this.assignment.reviewerId && this.assignmentToDo.todosCompletableByReviewerOnly) {
          return true;
        }

        return false;
      },
      userCanUncomplete() {
        if (!this.assignmentToDo.completed) {
          return false;
        }

        if (this.hasRole('System Administrator')) {
          return true;
        }

        return false;
      },
    },

    mounted() {
      this.getAssignmentToDo();
      this.getToDoFeedback();
    },

    methods: {
      async getAssignmentById() {
        this.loadingAssignment = true;
        try {
          const { data } = await axios.get(
            `/api/user/assignments/${this.assignmentToDo.userAssignmentId}`,
          );
          this.assignment = data;
          this.loadingAssignment = false;
        } catch (error) {
          this.$toast.open({
            message: error.message,
            color: 'red-500',
            duration: 4000,
          });
          this.loadingAssignment = false;
        }
      },
      async getToDoFeedback() {
        this.loadingFeedback = true;
        try {
          const { data } = await axios.get(
            `/api/assignments/todos/${this.toDoId}/feedback`,
          );
          this.toDoFeedback = data;
          this.loadingFeedback = false;
        } catch (error) {
          this.$toast.open({
            message: error.message,
            color: 'red-500',
            duration: 4000,
          });
          this.loadingFeedback = false;
        }
      },

      async getAssignmentToDo() {
        this.loadingToDo = true;
        try {
          const { data } = await axios.get(
            `/api/user/to-dos/${this.toDoId}`,
          );
          this.assignmentToDo = data;
          await this.getAssignmentById(this.assignmentToDo.userAssignmentId);
          this.loadingToDo = false;
          this.assignmentToDoForm.content = this.assignmentToDo.content;
          this.assignmentToDoForm.submitted = this.assignmentToDo.submitted;
          this.assignmentToDoForm.completed = this.assignmentToDo.completed;
        } catch (error) {
          this.$toast.open({
            message: error.message,
            color: 'red-500',
            duration: 4000,
          });
          this.loadingToDo = false;
        }
      },

      async submitTodoForReview() {
        this.assignmentToDoForm.completed = false;
        this.assignmentToDoForm.submitted = true;
        this.assignmentToDoForm.content = this.assignmentToDo.content;
        this.loading = true;
        try {
          await axios.patch(
            `/api/user/to-dos/${this.assignmentToDo.id}`, this.assignmentToDoForm,
          );
          this.getAssignmentToDo();
          this.$toast.open({
            message: `${this.assignmentToDo.toDoItemName} submitted!`,
            color: 'green-500',
          });
          this.loading = false;
        } catch (error) {
          this.$toast.open({ message: error.message, color: 'red-500' });
          this.loading = false;
        }
      },

      async completeTodo() {
        this.assignmentToDoForm.completed = true;
        this.assignmentToDoForm.submitted = true;
        this.assignmentToDoForm.content = this.assignmentToDo.content;
        this.loading = true;
        try {
          await axios.patch(
            `/api/user/to-dos/${this.assignmentToDo.id}`, this.assignmentToDoForm,
          );
          this.getAssignmentToDo();
          this.$toast.open({
            message: `${this.assignmentToDo.toDoItemName} ToDo marked as completed!`,
            color: 'green-500',
          });
          this.loading = false;
        } catch (error) {
          this.$toast.open({ message: error.message, color: 'red-500' });
          this.loading = false;
        }
      },

      async uncompleteTodo() {
        this.assignmentToDoForm.completed = false;
        this.assignmentToDoForm.submitted = false;
        this.loading = true;
        try {
          await axios.patch(
            `/api/user/to-dos/${this.assignmentToDo.id}`, this.assignmentToDoForm,
          );
          this.getAssignmentToDo();
          this.$toast.open({
            message: `${this.assignmentToDo.toDoItemName} ToDo marked as not completed!`,
            color: 'green-500',
          });
          this.loading = false;
        } catch (error) {
          this.$toast.open({ message: error.message, color: 'red-500' });
          this.loading = false;
        }
      },

      launchToDoFeedbackSideDrawer() {
        this.$sideDrawer.open({
          parent: this,
          component: FeedbackSideDrawer,
          props: {
            entityId: Number(this.toDoId),
            userId: this.user.id,
            type: 'ToDo',
          },
          events: {
            getFeedback: () => this.getToDoFeedback(),
          },
        });
      },

      launchIndividualAssigneesSideDrawer() {
        this.$sideDrawer.open({
          parent: this,
          component: IndividualAssigneeSideDrawer,
          props: {
            assignmentTemplateId: this.assignment.assignmentTemplateId,
            userId: this.assignment.userId,
          },
        });
      },

      launchGroupAssigneesSideDrawer() {
        this.$sideDrawer.open({
          parent: this,
          component: GroupAssigneesSideDrawer,
          props: {
            groupName: this.assignment.assignmentTemplateGroupName,
            assignmentTemplateId: this.assignment.assignmentTemplateId,
          },
        });
      },

    },
  };
</script>